/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMetadataEntryDTO
 */
export interface UserMetadataEntryDTO {
    /**
     * 
     * @type {string}
     * @memberof UserMetadataEntryDTO
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataEntryDTO
     */
    value: string;
}

/**
 * Check if a given object implements the UserMetadataEntryDTO interface.
 */
export function instanceOfUserMetadataEntryDTO(value: object): value is UserMetadataEntryDTO {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UserMetadataEntryDTOFromJSON(json: any): UserMetadataEntryDTO {
    return UserMetadataEntryDTOFromJSONTyped(json, false);
}

export function UserMetadataEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMetadataEntryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
    };
}

export function UserMetadataEntryDTOToJSON(value?: UserMetadataEntryDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'key': value['key'],
        'value': value['value'],
    };
}

